import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import HttpClientXml from "../../../utils/HttpClientXml";
import moment from "moment";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { calculateDaysAgo } from "../../../utils/Helper";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function ExpenseReport() {

  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");

  const [cities, setCities] = useState([]);

  const [months, setMonths] = useState([
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" }
  ]);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, index) => ({
    id: index,
    name: currentYear - 9 + index
  }));

  // Fetch cities
  const fetchCities = async () => {
    try {
      const res = await HomeService.getCities();
      if (res?.data) {
        setCities(res.data)
        if (userCity) {
          setCities([res.data.find(item => item._id === userCity)])
        }
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  }

  const columns = [
    // { name: "City", selector: (row) => row.City, sortable: true },
    // { name: "Year", selector: (row) => row.Year },
    { name: "Month", selector: (row) => row.Month, sortable: true },

    // { name: "Property", selector: (row) => row.propertyType, sortable: true },
    {
      name: "Salary",
      cell: (row) => (
        <><i class="fa fa-indian-rupee-sign"
          style={{
            marginRight: "3px"
          }}
        ></i> {row.Salary}</>
      ),
    },
    {
      name: "Rent",
      cell: (row) => (
        <><i class="fa fa-indian-rupee-sign"
          style={{
            marginRight: "3px"
          }}
        ></i> {row.Rent}</>
      ),
    },
    {
      name: "Electricity",
      cell: (row) => (
        <><i class="fa fa-indian-rupee-sign"
          style={{
            marginRight: "3px"
          }}
        ></i> {row.Electricity}</>
      ),
    },
    {
      name: "Telephone & Internet",
      cell: (row) => (
        <><i class="fa fa-indian-rupee-sign"
          style={{
            marginRight: "3px"
          }}
        ></i> {row.Telephone_Internet}</>
      ),
    },
    {
      name: "Petrol",
      cell: (row) => (
        <><i class="fa fa-indian-rupee-sign"
          style={{
            marginRight: "3px"
          }}
        ></i> {row.Petrol}</>
      ),
    },
    {
      name: "Miscellaneous",
      cell: (row) => (
        <><i class="fa fa-indian-rupee-sign"
          style={{
            marginRight: "3px"
          }}
        ></i> {row.Miscellaneous}</>
      ),
    },
    {
      name: "Total",
      cell: (row) => (
        <><i class="fa fa-indian-rupee-sign"
          style={{
            marginRight: "3px"
          }}
        ></i> {row.Total}</>
      ),
      sortable: true
    },
  ];

  const [filterData, setFilterData] = useState({
    city: userCity || "",
    year: moment().year().toString(),
    month: "",
  })

  useEffect(() => {
    // fetchProperties();
    fetchCities()
  }, []);

  const [reportData, setReportData] = useState([])

  const handleDownload = async (e) => {
    e.preventDefault();

    if (!filterData.city) { return toast.error("Please choose a city") }
    const data = {
      city: filterData.city,
      year: filterData.year,
      // ...(filterData.month && { month: Math.abs(filterData.month) })
      ...(filterData.month && { month: filterData.month })
    };

    console.log("HD149", data);
    // return
    try {
      const res = await HomeService.filterExpenseReport(data);
      if (res?.success) {
        console.log("REP162", res.data);

        toast.success("Report generated successfully!");
        const exportableData = res.data?.map((item, index) =>
        ({
          // Sl: index + 1,
          // Month: months.find((m) => m.id === Math.abs(filterData.month))?.name,
          // City: cities.find((c) => c._id === filterData.city)?.name,
          Year: item?.year,
          Month: item?.month,
          City: item?.city,
          Rent: item?.rent,
          Electricity: item?.electricity,
          Telephone_Internet: item?.["t&i"],
          Petrol: item?.petrol,
          Salary: item?.salary,
          Miscellaneous: item?.miscellaneous,
          Total: item?.total,
        })
        )

        setReportData(exportableData || [])
        console.log("EXP531", months.find((m) => m.id === Math.abs(filterData.month))?.name);

        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        // const fileName = `EXPENSES_${cities.find((c) => c._id === filterData.city)?.name}_${filterData.month && months.find((m) => m.id === Math.abs(filterData.month))?.name}${filterData.year}`;
        const fileName = `EXPENSES_${cities.find((c) => c._id === filterData.city)?.name}_${filterData.month}${filterData.year}`;


        const ws = XLSX.utils.json_to_sheet(exportableData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        saveAs(data, fileName + fileExtension);
      }
    } catch (error) {
      toast.error("Failed to Generate Report.");
      console.error("Error Generating Report:", error);
    }
  };

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid" id="edit-section">
        <div className="mt-5">
          <h2 className="text-center" style={headLineStyle}>
            Expense Report
          </h2>
          <hr />
          <section className="chartBox_area">
            <div className="row">


              <div className="col-md-2 mt-3">
                <label>
                  City
                </label>
                <select
                  className="form-control"
                  name="city"
                  value={filterData.city}
                  onChange={(e) => setFilterData({ ...filterData, city: e.target.value })}
                  required
                >
                  <option value="">---Select City---</option>
                  {cities.map((city, key) => (
                    <option key={key} value={city._id}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-2 mt-3">
                <label>
                  Year
                </label>
                <select
                  className="form-control"
                  name="year"
                  value={filterData?.year || ""}
                  onChange={(e) => setFilterData({ ...filterData, year: e.target.value })}
                >
                  <option value="" disabled>---Select---</option>
                  {years.map((item, index) => (
                    <option key={index} value={item.name}>
                      {item.name}
                    </option>
                  ))}
                </select>

              </div>

              <div className="col-md-2 mt-3">
                <label htmlFor="name">
                  Month
                </label>
                <select
                  className="form-control"
                  name="month"
                  value={filterData?.month || ""}
                  onChange={(e) => setFilterData({ ...filterData, month: e.target.value })}
                >
                  <option value="">---All month---</option>
                  {months.map((item, index) => (
                    <option key={index} value={item.name}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>


              <div className="col-md-2 mt-3"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                }}
              >
                <button
                  style={{
                    background: 'rgb(133, 218, 79)',
                    borderRadius: '13px',
                    width: "fit-content",
                    height: "fit-content",
                  }}
                  type="submit" className="btn mt-3"
                  onClick={(e) => {
                    handleDownload(e)
                  }}
                >
                  Download Report
                </button>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12 mt-3">
                <DataTable
                  columns={columns}
                  data={reportData}
                  pagination
                  persistTableHead
                  paginationPerPage={12}
                  paginationRowsPerPageOptions={[12, 25, 50]}
                />
              </div>
            </div>

          </section>
        </div>
      </div>
    </div>
  );
}

export default ExpenseReport;
